import React from 'react';
import * as S from './style';
import FileImg, { Props as FileImgProps } from 'components/atoms/FileImg';
import { ChkBox, FormItem, SpaceDiv, BtnNext, FormCarEtc, ContentsContainer, BtnContainer, Label } from 'components';
import InputOnlyNumber, { Props as InputOnlyNumberProps } from 'components/atoms/InputOnlyNumber';
import SelectBox, { Props as SelectBoxProps } from 'components/atoms/SelectBox';
import ZimssaConstant from 'commons/ZimssaConstant';
import { LABEL_CARINFO_TYPE, LABEL_CARINFO_SIZE, TITLE_CAR_INFO, LABEL_CAR_IMAGE, LABEL_CARINFO_COLOR, LABEL_CAR_NUMBER } from 'commons/ZimssaString';

interface Props {
    image: FileImgProps;
    type: SelectBoxProps;
    carLocation: SelectBoxProps;
    carNumber1: InputOnlyNumberProps;
    carNumber2: SelectBoxProps;
    carNumber3: InputOnlyNumberProps;

    size: SelectBoxProps;
    etc: { onChangeHandle: (value: string) => void };
    color: {
        state: string;
        onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, value?: any) => void;
    };
    btnNext: {
        contents: string;
        isActive: boolean;
        isComplete: boolean;
        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    };
}

function CarInfoRegister({ ...props }: Props): React.ReactElement {
    return (
        <S.CarInfoRegister>
            <ContentsContainer title={TITLE_CAR_INFO}>
                <FormItem label={LABEL_CAR_IMAGE}>
                    <FileImg {...props.image} />
                </FormItem>
                <FormItem label={LABEL_CARINFO_TYPE}>
                    <SelectBox {...props.type} />
                </FormItem>

                <FormItem
                    label={LABEL_CAR_NUMBER}
                    caption={!props.carNumber1.isValid || !props.carNumber3.isValid ? <Label contents={'차량 번호를 확인 해주세요.'} color={'red_900'} fontStyle={'caption'} /> : null}
                    optionalChildren={[
                        <InputOnlyNumber key={0} maxLength={3} {...props.carNumber1} />,
                        <SelectBox key={1} {...props.carNumber2} />,
                        <InputOnlyNumber key={2} maxLength={4} {...props.carNumber3} />,
                    ]}
                >
                    <SelectBox {...props.carLocation} />
                </FormItem>

                <FormItem label={LABEL_CARINFO_SIZE}>
                    {/* <SelectBox {...props.size}>{ZimssaConstant.CAR_INFO.SIZE_SMALL}</SelectBox> */}
                    <SelectBox {...props.size} />
                </FormItem>
                <FormCarEtc inputName={'btnEtc'} {...props.etc} />
                <FormItem label={LABEL_CARINFO_COLOR} itemType={'ROW'}>
                    {ZimssaConstant.CAR_INFO.COLOR_TEXT.map((item, index) => (
                        <ChkBox key={index} title={item.name} value={item.value} checked={item.value === props.color.state} {...props.color} />
                    ))}
                </FormItem>
            </ContentsContainer>
            <SpaceDiv height={36} />
            <BtnContainer>
                <BtnNext {...props.btnNext} />
            </BtnContainer>
        </S.CarInfoRegister>
    );
}

export default CarInfoRegister;
